export default __webpack_public_path__ + "static/media/logo-us-calvinklein.c4ad1bd2.svg";